import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const HoleDetections = Loader(
  lazy(() => import('content/pages/Private/Hole/Detections')),
);

const HolePage = Loader(lazy(() => import('content/pages/Private/Hole')));

const holeDetectionRouter: RouteObject[] = [
  {
    path: 'holes',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <HoleDetections />,
      },
      {
        path: ':image_id',
        element: <HolePage />,
      },
    ],
  },
];

export default holeDetectionRouter;
